var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photo-lower-bar-button-group" }, [
    _c(
      "div",
      { staticClass: "photo-lower-bar-button", on: { click: _vm.editPhoto } },
      [
        _c("SVGAdminEditRow", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Редактировать")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.showModal("photo-delete-modal")
          }
        }
      },
      [
        _c("SVGPhotoDelete", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Удалить")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }